import { SystemLocale } from '@ninja/utilities';
import { PlanDetailsSchema } from '@shory-health-individual/customer-api';
import { AppInit } from '../../../../server';

export type PlanKeyBenefits = {
	benefitName: string;
	benefitCategoryId: number;
	isKeyBenefit: boolean;
}[];

export const getKeyBenefits = (planKeyBenefits: PlanDetailsSchema['planKeyBenefits'], locale: SystemLocale) => {
	const { getBenefitCategoryById } = new AppInit(locale);

	const keyBenefits = planKeyBenefits
		?.map((pb) => {
			const benefit = getBenefitCategoryById(pb.benefitCategoryId);

			return { ...pb, benefitName: benefit?.shortName ?? '' };
		})
		.filter((kb) => kb.benefitName);

	return keyBenefits;
};
